import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const LoginNameKey = 'Admin-LoginName'



export function getCookie(key) {
  return Cookies.get(key)
}

export function setCookie(key,val) {
  return Cookies.set(key,val)
}

export function removeCookie(key) {
  return Cookies.remove(key)
}



export function getToken() {
  return getCookie(TokenKey)
}

export function setToken(token) {
  return setCookie(TokenKey, token)
}

export function removeToken() {
  return removeCookie(TokenKey)
}



export function getLoginName() {
  return getCookie(LoginNameKey)
}

export function setLoginName(val) {
  return setCookie(LoginNameKey,val)
}